import { useQuery } from '@tanstack/react-query';

import { FormField, api, getQueryProps } from 'common';

import { APPOINTMENT_KIND_TYPE_NAME } from '../../../../../../OrchestratorInstance/common';
import { useFlowDefinitionContext } from '../../../../context';
import { BlockAutocomplete } from '../../ConfigFields/Autocomplete/Autocomplete';
import { SearchableProviderPicker } from '../../ConfigFields/Autocomplete/SearchableProviderPicker';
const PRACTICE_IDS_HELPER_TEXT = 'Select a practice from the org for the appointment';

const APPOINTMENT_TYPES_HELPER_TEXT = 'Select the type of appointment to be scheduled.';

export function SchedulingFormFields() {
  const {
    flowDefinition: { organizationId },
  } = useFlowDefinitionContext();
  const { data: practices = [] } = useQuery({
    ...getQueryProps(api.client.Practice, 'findAll', {
      organizationId,
    }),
  });
  const allPracticesMap = Object.fromEntries(practices.map((practice) => [practice.id, practice]));
  const { data: allAppointmentTypes = [] } = useQuery({
    ...getQueryProps(api.client.Orchestrator.CanonicalField, 'findAll', {
      canonicalFieldTypeName: APPOINTMENT_KIND_TYPE_NAME,
    }),
  });
  const allAppointmentTypesMap = Object.fromEntries(
    allAppointmentTypes.map((appointmentType) => [appointmentType.value, appointmentType.name])
  );
  return (
    <FormField
      id="config"
      label="Slot filter configs"
      error={'' /** FIXME: Add node block errors */}
    >
      <SearchableProviderPicker
        fieldName="config.providerUserIds"
        label="Provider Ids"
        organizationId={organizationId}
        helperText="Enter provider ID for the appointment."
      />
      <BlockAutocomplete
        fieldName="config.practiceIds"
        label="Practice Ids"
        options={Object.keys(allPracticesMap)}
        getOptionLabel={(practiceId) =>
          allPracticesMap?.[practiceId]?.name || allPracticesMap?.[practiceId]?.name || practiceId
        }
        multiple
        helperText={PRACTICE_IDS_HELPER_TEXT}
      />
      <BlockAutocomplete
        fieldName="config.appointmentTypes"
        label="Appointment Types"
        options={Object.keys(allAppointmentTypesMap)}
        getOptionLabel={(appointmentKind) => allAppointmentTypesMap[appointmentKind]}
        multiple
        helperText={APPOINTMENT_TYPES_HELPER_TEXT}
      />
    </FormField>
  );
}
